/*eslint-disable*/

export default class SpendingBudgetData {
  constructor() {
    this.key = null;
    this.value = null;
    this.name = null;
    this.current_month = null;
    this.isArchived = null;
    this.path = null;
    this.budgetAmount = null;
    this.category_budgets = null;
    this.tag_budget = null;

    this.last_month = null;
    this.last_month_flag = null;
    this.difference = null;
    this.message = null;
  }
  getTagID() {
    return this.id;
  }
  getTagValue() {
    return this.value;
  }
  getBudgetAmount() {
    return this.budgetAmount;
  }
  getTagType() {
    return this.tagType;
  }
  setLastMonth(value) {
    this.last_month = value;
  }
  setCurrentMonth(value) {
    this.current_month = value;
  }
  setLastMonthFlag(value) {
    this.last_month_flag = value;
  }
}
